import { useNavigate } from 'react-router-dom';
import AdminReports from '../../../components/AdminReports';

const SchedulerSetupView = () => {
  const currentUrl = window.location.pathname;
  const navigate = useNavigate();

  return (
    <div className='w-full overflow-y-scroll bg-opacity-10 bg-navy-bright flex flex-col justify-start items-center'>
      <div className='bg-white rounded-2xl w-full md:w-5/6 xl:w-2/3 md:mr-5 my-6 flex flex-shrink flex-col border border-navy-light'>
        <div className='h-16 relative flex justify-between items-center px-6  rounded-t-xl border-b border-navy-light bg-opacity-20 bg-navy-bright'>
          <h1 className='text-xl font-semibold text-dark-blue'>Scheduler Tools</h1>
          <img src='/main-logo-dark.svg' alt='Main Logo' className='w-[130px]' />
        </div>
        <div className='flex flex-col sm:flex-row'>
          <div className='p-3 border-t sm:border-t-0 border-navy-light bg-opacity-20 bg-navy-bright w-full sm:w-1/5 flex flex-row sm:flex-col'>
            <div
              className={`p-2 rounded-md cursor-pointer select-none  ${currentUrl === '/scheduler/setup/reports' ? 'bg-opacity-30 bg-navy-bright' : 'text-opaque-job-details-gray'}`}
              onClick={() => navigate('/scheduler/setup/reports')}
            >
              Reports
            </div>
          </div>
          <div className='flex flex-col w-full sm:w-4/5 py-7 px-3'>
            {currentUrl === '/scheduler/setup/reports' && <AdminReports />}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SchedulerSetupView;
